import * as React from "react";

import type { Thread } from "../../types/collaborateThread";
import { threadNeedsSignoff } from "../../utils/signoffAccess";

export type SignoffRouteMetaProps = {
  from: string;
  to: string;
};

export function SignoffRouteMeta({ from, to }: SignoffRouteMetaProps) {
  return (
    <div className="collaborate-signoff-route">
      {from} → {to}
    </div>
  );
}

export function SignoffRouteMetaFromThread({ thread }: { thread: Thread }) {
  if (!threadNeedsSignoff(thread) || !thread.assignee) {
    return null;
  }

  return <SignoffRouteMeta from={thread.createdBy.name} to={thread.assignee.name} />;
}

export default SignoffRouteMetaFromThread;
